var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Card, Text, Tooltip, TooltipTrigger } from '@philips-internal/oswald-ui-components';
import { ReactComponent as ReadSVG } from '@philips-internal/oswald-ui-components/resources/assets/components/status/check.svg';
import { ReactComponent as NotReadSVG } from '@philips-internal/oswald-ui-components/resources/assets/components/status/warning.svg';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool, eventListener, number, object, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { generateUUID, isFunction, trigger } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as AttachSVG } from '../../assets/images/icons/attach_icon.svg';
import { ReactComponent as MessageSVG } from '../../assets/images/icons/message_normal.svg';
import { ReactComponent as MessageUrgentSVG } from '../../assets/images/icons/message_urgent.svg';
import './message-card.css';
import MessageCardApi from './message-card-api';
const COLOR_BLUE = '#1477a9';
let MessageCard = class MessageCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        ...this.props,
                    },
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener,
        id: number,
        message: object,
        attach: bool,
        read: bool,
        sentDate: string,
        urgent: bool,
        subject: string,
    }; }
    renderMainIcon() {
        const { urgent } = this.props;
        if (urgent) {
            return (React.createElement(Tooltip, { value: "message-card.urgent" },
                React.createElement("div", null,
                    React.createElement(MessageUrgentSVG, { fill: COLOR_BLUE }))));
        }
        return (React.createElement(Tooltip, { value: "message-card.normal" },
            React.createElement("div", null,
                React.createElement(MessageSVG, { fill: COLOR_BLUE }))));
    }
    renderIconAttach() {
        const { attach } = this.props;
        if (attach) {
            return (React.createElement(Tooltip, { value: "message-card.attach" },
                React.createElement("div", null,
                    React.createElement(AttachSVG, { fill: COLOR_BLUE }))));
        }
        return (React.createElement("div", null));
    }
    renderReadStatus() {
        const { read } = this.props;
        if (read) {
            return (React.createElement(Tooltip, { value: "message-card.read" },
                React.createElement("div", null,
                    React.createElement(ReadSVG, { fill: "#3fb463" }))));
        }
        return (React.createElement(Tooltip, { value: "message.not-read" },
            React.createElement("div", null,
                React.createElement(NotReadSVG, { fill: COLOR_BLUE }))));
    }
    render() {
        const { sentDate, subject } = this.props;
        const formatter = {
            value: {
                name: 'date-locale',
            },
        };
        return (React.createElement(Card, { className: "c-message-card", onClick: trigger(this.onClick), selectionType: SelectionType.NONE, transparent: true, uuid: generateUUID(), width: 12 },
            React.createElement("div", { className: "c-message-card__wrapper" },
                React.createElement("div", { className: "c-message-card__content" },
                    React.createElement("div", { className: "c-message-card__section c-message-card__left" }, this.renderMainIcon()),
                    React.createElement("div", { className: "c-message-card__section c-message-card__center" },
                        React.createElement("div", { className: "c-message-card__center-title" },
                            React.createElement(Text, { value: sentDate, formatters: formatter }),
                            " ",
                            this.renderIconAttach()),
                        React.createElement(Tooltip, { value: subject, triggers: [TooltipTrigger.ELLIPSIS] },
                            React.createElement("span", { className: "c-message-card__prop" }, subject))),
                    React.createElement("div", { className: "c-message-card__section c-message-card__right" }, this.renderReadStatus())))));
    }
};
MessageCard = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: MessageCardApi })
], MessageCard);
export default MessageCard;
//# sourceMappingURL=message-card.js.map